import gql from 'graphql-tag'

export const UPDATE_COMPARE_LIST = gql`
  mutation UpdateCompareList(
    $productErpIdentifier: String!
    $quantity: Int!
    $productListName: String
  ) {
    updateCompareListWithProduct(
      productErpIdentifier: $productErpIdentifier
      quantity: $quantity
      productListName: $productListName
    ) {
      productListId
      productListItemId
    }
  }
`
